/**
 * v2 글자 크기 단계 (FIKET-384)
 *
 * html.v2 의 루트 font-size 를 바꿔 rem 기반 Tailwind 크기·여백 전체를 비례 확대한다
 * (브라우저 줌과 같은 효과, v1 라우트는 .v2 클래스가 없어 무영향).
 * 실제 배율은 index.css 의 `.v2[data-font-scale=…]` 블록에 있고, 여기서는
 * 단계 정의 · 저장 · html 속성 반영만 담당한다.
 */

export type FontScaleKey = 'md' | 'lg' | 'xl'

export interface FontScaleOption {
  key: FontScaleKey
  label: string
  /** 본문(text-sm) 기준 px — 라벨 표시용 */
  bodyPx: number
}

export const FONT_SCALES: readonly FontScaleOption[] = [
  { key: 'md', label: '보통', bodyPx: 14 },
  { key: 'lg', label: '크게', bodyPx: 16 },
  { key: 'xl', label: '더 크게', bodyPx: 18 },
]

/** 기본은 '크게'(본문 16px) — 기존 14px 이 너무 작다는 피드백 반영 */
export const DEFAULT_FONT_SCALE: FontScaleKey = 'lg'

const STORAGE_KEY = 'fiket-admin:v2-font-scale'
const DATA_ATTR = 'fontScale' // → html[data-font-scale]

export function parseFontScale(raw: string | null | undefined): FontScaleKey {
  return FONT_SCALES.some((s) => s.key === raw) ? (raw as FontScaleKey) : DEFAULT_FONT_SCALE
}

/** localStorage 저장값 로드 (접근 불가·없음·손상 시 기본값) */
export function loadFontScale(): FontScaleKey {
  try {
    return parseFontScale(window.localStorage.getItem(STORAGE_KEY))
  } catch {
    return DEFAULT_FONT_SCALE
  }
}

/** html[data-font-scale] 반영 — CSS 가 이 속성으로 루트 font-size 를 결정 */
export function applyFontScale(key: FontScaleKey) {
  document.documentElement.dataset[DATA_ATTR] = key
}

export function clearFontScale() {
  delete document.documentElement.dataset[DATA_ATTR]
}

/** 저장 + 즉시 반영 */
export function saveFontScale(key: FontScaleKey) {
  try {
    window.localStorage.setItem(STORAGE_KEY, key)
  } catch {
    // 프라이빗 모드 등 저장 실패는 무시 — 세션 내 반영은 유지
  }
  applyFontScale(key)
}
